import { ReactComponent as SvgDrawerOpenIcon } from "assets/drawer-open.svg";
import NameLogo from "components/NameLogo";
import { SignUpButton } from "components/SignUpButton";
import googleTagManagerId from "constants/googleTagManagerId";
import { openDrawer } from "features/NavigationDrawer/slice";
import React from "react";
import { NavLink } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import styled from "styled-components/macro";
import { HEADER_HEIGHT } from "styles/constants";
import helpers from "styles/helpers";
import { mediaMin } from "styles/media";

const Header = styled.header`
  position: fixed;
  height: ${HEADER_HEIGHT}px;
  width: 100%;
  background-color: ${({ theme }) => theme.background};
  top: 0;

  z-index: 3;
  padding: 0 16px;

  ${mediaMin.md`
    padding: 0 56px;
  `};

  ${helpers.transition("top")};
`;

const LogoWrapper = styled.div`
  display: flex;
  padding: 8px;
`;

const StyledNameLogo = styled(NameLogo)`
  width: 96px;
`;

const HeaderContents = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 16px;

  ${mediaMin.sm`
    gap: 48px;
  `}
`;

const StyledNavLink = styled(NavLink)`
  display: none;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  padding: 8px;

  &:hover {
    color: ${({ theme }) => theme.palette.gray400};
  }

  ${helpers.transition("color")};

  ${mediaMin.sm`
    display: block;
  `}
`;

const DrawerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.palette.white};

  ${mediaMin.sm`
    display: none;
  `}
`;

export function HeaderBar() {
  const dispatch = useAppDispatch();

  const handleClickDrawerButton = () => {
    dispatch(openDrawer());
  };

  return (
    <Header>
      <HeaderContents>
        <div>
          <NavLink to="/" data-gtm-id={googleTagManagerId.Landing_Logo_Button}>
            <LogoWrapper>
              <StyledNameLogo />
            </LogoWrapper>
          </NavLink>
        </div>
        <RightSide>
          <StyledNavLink to="/product">Product</StyledNavLink>
          <StyledNavLink to="/about">About</StyledNavLink>
          <StyledNavLink to="/signin">Sign in</StyledNavLink>
          <SignUpButton />
          <DrawerButton onClick={handleClickDrawerButton}>
            <SvgDrawerOpenIcon />
          </DrawerButton>
        </RightSide>
      </HeaderContents>
    </Header>
  );
}
